"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var SearchParameter = /** @class */ (function () {
    function SearchParameter(parameterNames, searchString, rtl) {
        var _this = this;
        var _a;
        this.primaryText = '';
        this.criterias = parameterNames.map(function (p) {
            return ({ name: p.name, value: undefined, definition: __assign({}, p) });
        });
        this.defaultParameterName = (_a = parameterNames.find(function (p) { return p.default === true; })) === null || _a === void 0 ? void 0 : _a.name;
        var parameterNamesToSearch = parameterNames.filter(function (p) { return p.default !== true; }).map(function (c) { return c.name; });
        var regExExpression = rtl ? "((" + parameterNamesToSearch.join('|') + "):)" : "(\\b(" + parameterNamesToSearch.join('|') + "):)";
        var regEx = new RegExp(regExExpression, 'gi');
        var position = 0;
        var criteriaName = '';
        if (searchString) {
            var match = void 0;
            do {
                match = regEx.exec(searchString);
                if (match) {
                    if (criteriaName === '') {
                        if (match.index > 0) {
                            this.primaryText = searchString.substring(0, match.index).trim();
                        }
                    }
                    else {
                        // eslint-disable-next-line no-loop-func
                        var criteria = this.criterias.find(function (c) { return c.name === criteriaName; });
                        if (criteria) {
                            criteria.value = searchString.substring(position, match.index).trim();
                        }
                    }
                    position = match.index + match[0].length;
                    criteriaName = match[2];
                    // eslint-disable-next-line no-loop-func
                    var fixedCriterianame = parameterNames.find(function (c) { return c.name.toLowerCase() === criteriaName.toLowerCase(); });
                    if (fixedCriterianame) {
                        criteriaName = fixedCriterianame.name;
                    }
                }
            } while (match);
            if (criteriaName) {
                // eslint-disable-next-line no-loop-func
                var criteria = this.criterias.find(function (c) { return c.name === criteriaName; });
                if (criteria) {
                    criteria.value = searchString.substring(position).trim();
                }
            }
            if (this.primaryText === '' && this.criterias.find(function (c) { return c.value !== undefined; }) === undefined) {
                this.primaryText = searchString;
            }
        }
        if (this.defaultParameterName) {
            var criteria = this.criterias.find(function (c) { return c.name === _this.defaultParameterName; });
            if (criteria) {
                criteria.value = this.primaryText;
            }
        }
    }
    Object.defineProperty(SearchParameter.prototype, "hasCritieras", {
        get: function () {
            var _this = this;
            return this.criterias.filter(function (c) { return c.name !== _this.defaultParameterName; }).findIndex(function (c) { return c.value && c.value.trim() !== ''; }) !== -1;
        },
        enumerable: true,
        configurable: true
    });
    SearchParameter.prototype.toString = function () {
        var _this = this;
        var _a;
        if (this.defaultParameterName) {
            var criteria = this.criterias.find(function (c) { return c.name === _this.defaultParameterName; });
            return (((_a = criteria === null || criteria === void 0 ? void 0 : criteria.value) !== null && _a !== void 0 ? _a : '') + " " + this.criterias.filter(function (c) { return c.value && c.name !== _this.defaultParameterName; }).map(function (c) { return c.name + ": " + c.value; }).join(' ')).trim();
        }
        return (this.primaryText + " " + this.criterias.filter(function (c) { return c.value; }).map(function (c) { return c.name + ": " + c.value; }).join(' ')).trim();
    };
    return SearchParameter;
}());
exports.SearchParameter = SearchParameter;
//# sourceMappingURL=SearchParameters.js.map